import JobPositionTable from 'components/tables/JobPositionTable';
import { _t } from 'lang';
import DashboardLayout from 'layouts/dashboard-layout/DashboardLayout';
import DashboardPageHeading from 'layouts/dashboard-layout/headers/DashboardPageHeading';
import SettingsSidebar from 'layouts/dashboard-layout/sidebars/settings-sidebar/SettingsSidebar';
import { useNavigate } from 'react-router-dom';
import { ADD_JOB_POSITION_PAGE_PATH } from 'routes/paths';

/**
 * Job positions page.
 *
 * @see https://www.figma.com/file/X3Zklb3KjOZFu5wAHgGYoH/Toolio---web-Interface?node-id=282%3A8141
 */
export default function JobPositionsPage() {
  const navigate = useNavigate();

  return (
    <DashboardLayout sidebar={<SettingsSidebar />}>
      <div className="relative h-full p-[20px] pt-0">
        <DashboardPageHeading
          heading={_t('Job positions')}
          buttonAction={() => navigate(ADD_JOB_POSITION_PAGE_PATH.original)}
        />
        <JobPositionTable />
      </div>
    </DashboardLayout>
  );
}
